import React from "react";


const Navbar = () => {
return (
    <div className="container-fluid bg-primary">
            <div className="container">
                <nav className="navbar navbar-dark navbar-expand-lg py-0">
                    <a href="/" className="navbar-brand">
                        <h1 className="text-white fw-bold d-block">Influ-<span className="text-secondary">encer</span> </h1>
                    </a>
                    <button 
            type="button" 
            className="navbar-toggler me-0" 
            data-bs-toggle="collapse" 
            data-bs-target="#navbarCollapse"
            aria-expanded="false" 
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse bg-transparent" id="navbarCollapse">                       
             <div className="navbar-nav ms-auto mx-xl-auto p-0">
                            <a href="/" className="nav-item nav-link active text-secondary">Home</a>
                            <a href="/about" className="nav-item nav-link">About</a>
                            <a href="/service" className="nav-item nav-link">Services</a>
                            <a href="/contact" className="nav-item nav-link">Contact</a>
                        </div>
                        <div className="d-flex align-items-center ms-3">
                            <a href="/login" className="btn btn-light me-2">Login</a>
                            <a href="/register" className="btn btn-secondary">Register</a>
                        </div>
                    </div>
                    <div className="d-none d-xl-flex flex-shrink-0">
                        <div id="phone-tada" className="d-flex align-items-center justify-content-center me-4">
                            <a href="" className="position-relative animated tada infinite">
                                <i className="fa fa-phone-alt text-white fa-2x"></i>
                                <div className="position-absolute" style={{top: "-7px" , left: "20px"}}>
                                    <span><i className="fa fa-comment-dots text-secondary"></i></span>
                                </div>
                            </a>
                        </div>
                        <div className="d-flex flex-column pe-4 border-end">
                            <span className="text-white-50">Have any questions?</span>
                            <span className="text-secondary">Call: +1-332-600-5354</span>
                        </div>
                        <div className="d-flex align-items-center justify-content-center ms-4 ">
                            <a href="#"><i className="bi bi-search text-white fa-2x"></i> </a>
                        </div>
                    </div>
                </nav>
            </div>
        </div>
);
}
export default Navbar;